// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"panorama-vertical"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4.5 2L19.5 2C19.5 2 18 7 18 12C18 17 19.5 22 19.5 22L4.5 22C4.5 22 6 17 6 12C6 7 4.5 2 4.5 2Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4.5 2L19.5 2C19.5 2 18 7 18 12C18 17 19.5 22 19.5 22L4.5 22C4.5 22 6 17 6 12C6 7 4.5 2 4.5 2Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-panorama-vertical')
export default class PanoramaVerticalIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'panorama-vertical',
    }
  }
}
